import { Window, Cordova } from '@/types/window'
import { Platform } from '@/constants/app'

export const isCordovaEnvironment = (
  cordova = (window as Window).cordova
): cordova is Cordova => cordova !== undefined

export const isPlatformWindows = () => {
  const cordova = (window as Window).cordova

  return (
    isCordovaEnvironment(cordova) && cordova.platformId === Platform.WINDOWS
  )
}

export const isPlatformIOS = () => {
  const cordova = (window as Window).cordova

  return isCordovaEnvironment(cordova) && cordova.platformId === Platform.IOS
}

export const isPlatformAndroid = () => {
  const cordova = (window as Window).cordova

  return (
    isCordovaEnvironment(cordova) && cordova.platformId === Platform.ANDROID
  )
}
